import { Component, input, output } from '@angular/core';
import { ImagePreviewComponent } from '../../image-preview/image-preview.component';
import { IconComponent } from 'app/shared/icon/icon.component';
import { provideIcons } from '@ng-icons/core';
import { heroXMark } from '@ng-icons/heroicons/outline';
import { NgClass } from '@angular/common';
import { IPreviewUrls } from "../../file.model";

@Component({
  selector: 'app-file-upload-preview',
  standalone: true,
  imports: [ImagePreviewComponent, IconComponent, NgClass],
  templateUrl: './file-upload-preview.component.html',
  styles: ``,
  providers: [provideIcons({ heroXMark })],
  host: {
    class: 'flex gap-6 overflow-x-auto',
  },
})
export class FileUploadPreviewComponent {
  previewUrls = input.required<IPreviewUrls[]>();
  isSuggestions = input(false);
  selectedSuggestionsUrls = input<string[]>([]);
  remove = output<number>();
  suggestionSelected = output<string>();

  onItemClicked(item: IPreviewUrls) {
    if (this.isSuggestions()) {
      if (!this.isSuggestionSelected(item)) {
        this.suggestionSelected.emit(item.url);
      }
    }
  }

  onIconClicked(item: IPreviewUrls, index: number, event: Event) {
    event.stopPropagation();
    if (this.isSuggestions()) {
      if (this.isSuggestionSelected(item)) {
        this.remove.emit(index);
      } else {
        this.suggestionSelected.emit(item.url);
      }
    } else {
      this.remove.emit(index);
    }
  }

  isSuggestionSelected(item: IPreviewUrls): boolean {
    return this.isSuggestions() && this.selectedSuggestionsUrls()?.length
      ? this.selectedSuggestionsUrls().includes(item.url)
      : false;
  }
}
